export default "__VITE_ASSET__Bxrn$akG__"